import React, {
	useState,
	createContext,
	useContext,
	useMemo, 
} from 'react';
import PropTypes from 'prop-types';
import { is } from 'Common/Utils';
const { localStorage, JSON } = window;

const LocalContext = createContext({});

export const useLocal = (key) => {
	const context = useContext(LocalContext);
	if(key) {
		return {
			deleteLocal() {
				context.deleteLocal(key)
			},
			setLocal(value) {
				context.setLocal(key, value);
			},
			getLocal() {
				return context.getLocal(key)
			},
		}
	}
	return context
};

export const Local = ({ children, value = {} }) => {
	const [local, setLocal] = useState({
		...value,
		...Object.keys(localStorage).reduce(
			(result, key) => { 
				if(key !== 'length') {
					const item = localStorage.getItem(key) 
					result[key] = item.indexOf('{') === 0 ? JSON.parse(item) : item
				}
				return result
			}, {}
		),
	});
	const provide = useMemo(
		() => ({
			deleteLocal(name) {
				localStorage.removeItem(name);
				setLocal((prev) => {
					delete prev[name];
					return { ...prev };
				});
			},
			setLocal(name, value) {
				setLocal((prev) => {
					const update = is.fnc(value) ? value(prev[name]) : value;
					localStorage.setItem(name, JSON.stringify(update));
					return { ...prev, [name]: update };
				});
			},
			getLocal(name) {
				return local[name];
			},
			flushLocal() {
				localStorage.clear();
				setLocal(value);
			},
			getLocalAll() {
				return local;
			},
		}),
		[local, value]
	);

	return (
		<LocalContext.Provider value={provide}>{children}</LocalContext.Provider>
	);
};

Local.propTypes = {
	value: PropTypes.object,
	children: PropTypes.oneOfType([
		PropTypes.element,
		PropTypes.arrayOf(PropTypes.element),
	]),
};
